
import { Ajax, AjaxError, ISupportSpinner } from '../shared/Ajax';

import {LodgementPeriod} from '../models/LodgementPeriod'

export class LoginController extends Ajax {
    constructor() {
        super(window.__emdgBaseUrl, '/api/login');
    }
    
        login(owner:ISupportSpinner, success:{(res:string):any}, error?:AjaxError) {
    super._call('post', '', owner, null, null, success, error, 'text')
}

        logout(owner:ISupportSpinner, success:{(res:string):any}, error?:AjaxError) {
    super._call('post', 'logout', owner, null, null, success, error, 'text')
}

        getLatestLodgementPeriods(owner:ISupportSpinner, periodType:number, success:{(res:LodgementPeriod[]):any}, error?:AjaxError) {
    super._call('get', 'GetLodgementPeriods', owner, {periodType:periodType}, null, success, error)
}

        getAnnouncementString(owner:ISupportSpinner, success:{(res:string):any}, error?:AjaxError) {
    super._call('get', 'GetAnnouncement', owner, null, null, success, error, 'text')
}

        getAboutEmdgDescriptionString(owner:ISupportSpinner, success:{(res:string):any}, error?:AjaxError) {
    super._call('get', 'getAboutEmdgDescription', owner, null, null, success, error, 'text')
}
}
